import { Link } from "react-router-dom"
import "./style.css"
import { Data } from "../../utils/Data"

function Content() {
    return (
        <section className="videos">
            <div className="container-fluid">
                <div className="row justify-content-between">
                    {
                        Data.map(content => {
                            return <div
                                className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3 p-lg-3"
                                data-aos="fade-right"
                                data-aos-duration="1500"
                                key={content.title}
                            >
                                <Link
                                    to={`/contents/${content.routeName}`}
                                    className="content-title"
                                >
                                    <img className="image-fluid w-100" src={content.image} alt={content.title} />
                                </Link>
                            </div>
                        })
                    }
                </div>
            </div>
            <div className="videos-monkey--box" data-aos="zoom-in-up">
                <img src="/assets/images/boy.png" alt="Monkey down up" className="videos-monkey--image" />
            </div>
        </section>
    )
}

export default Content
